import { useContext, useState } from 'react';
import { Popover, Select, Avatar } from '@mantine/core';
import { ReactComponent as EditIcon } from 'assets/icons/editIcon.svg';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downArrow2.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/deleteIcon.svg';

import { ReactComponent as LocationIcon } from 'assets/icons/locationIcon.svg';
import { ReactComponent as MeetIcon } from 'assets/icons/personIcon.svg';

import dateFormatter from 'helper/dateFormatter';
import dayjs from 'dayjs';

import useEditCalendarEvent from 'pages/adminCalender/pages/organisation-calendar/hooks/useEditCalendarEvent';
import { AuthContext } from 'context/authContext';
import PrimaryButton from 'components/primaryButton';

export default function MeetingsEventComponent({
  event: calendarEvent,
  ...props
}) {
  const [eventPopover, setEventPopover] = useState(false);
  const [isDeletePopover, setIsDeletePopover] = useState(false);

  const {
    authState: { user_id },
  } = useContext(AuthContext);

  // Holiday Types
  // const holidayTypes = useGetHolidayTypes();

  // CALENDAR Events
  const editCalendarEventMutation = useEditCalendarEvent();

  // const formatTime = (time) => {
  //   if (time) {
  //     let hours = `${time[0]}${time[1]}`;
  //     const minutes = `${time[3]}${time[4]}`;
  //     const addAMorPM = hours >= 12 ? 'PM' : 'AM';
  //     hours = hours % 12;
  //     hours = hours
  //       ? // if hours are not equal to 0
  //         hours < 10
  //         ? '0' + hours
  //         : hours
  //       : // if hours are equal to 0, then we are assigning 12
  //         12;
  //     let strTime = hours + ':' + minutes + ' ' + addAMorPM;
  //     return strTime;
  //   }
  // };
  // console.log('calender event:', calendarEvent);
  console.log('calendarEvent:', calendarEvent);
  let eventClassName = 'rounded cursor-pointer pt-0.5 w-full';

  if (calendarEvent?.isBirthday) {
    eventClassName += ' text-585757 bg-E8E8E8';
  } else if (calendarEvent?.isHoliday) {
    eventClassName += ' text-BA34 bg-BA341A';
  } else {
    eventClassName += ' text-FF9F2D bg-FF961B1A';
  }
  return (
    <div
      className={`relative ${eventClassName}`}
      style={{ ...props?.children?.props?.style }}
      onClick={() => setEventPopover(true)}
    >
      <Popover
        opened={eventPopover}
        onClose={() => setEventPopover(false)}
        classNames={{
          root: 'w-[100%]',
        }}
        target={
          <div
            className={`bg-white w-full rounded  relative flex items-center h-12 ${
              calendarEvent?.type === 'meeting'
                ? 'bg-[#FFECEC]'
                : 'bg-[#FFF5E9]'
            } `}
          >
            <span
              className={`${
                calendarEvent?.type === 'meeting' ? 'bg-E92C2C' : 'bg-FF9F2D'
              }
           
        w-full h-[5px] top-0  absolute `}
            ></span>
            <div className='flex flex-col mb-2'>
              <p
                className='text-sm text-black font-normal 3xl:text-xl mt-2 ml-4  '
                onClick={() => setEventPopover(true)}
              >
                {calendarEvent?.isBirthday
                  ? `${calendarEvent?.title}'s birthday`
                  : calendarEvent?.title}
                {
                  // <span className='text-sm ml-4'>{props?.label}</span>
                }
              </p>
              <div className='flex justify-between'>
                <p className='text-[#979797] text-xs ml-4'>
                  {calendarEvent?.created_by_name}
                </p>
                <p className='text-[#979797] text-xs ml-4'>
                  {calendarEvent?.location}
                </p>
              </div>
            </div>
          </div>
        }
        placement='center'
        position='right'
        width={320}
        radius='md'
        shadow={'lg'}
        gutter={10}
        withArrow
        arrowSize={8}
        zIndex={20}
      >
        <div key={calendarEvent?.id}>
          <div className='flex items-center justify-between mb-1'>
            <p className='w-3/4 truncate font-semibold text-20'>
              {calendarEvent?.isBirthday
                ? `${calendarEvent?.title}'s birthday`
                : calendarEvent?.title}
            </p>

            {!calendarEvent?.isBirthday &&
              user_id === calendarEvent?.created_by_id && (
                <div className='flex items-center space-x-3'>
                  <EditIcon
                    className='cursor-pointer'
                    onClick={() => {
                      if (calendarEvent?.type === 'event') {
                        props?.setIsCalenderEventModalOpen(true);
                        props?.setSelectedEventId(calendarEvent?.id);
                      } else {
                        props?.setOpenModal(true);
                        props?.setSelectedEventId(calendarEvent?.id);
                        props?.setTitle('Edit Meeting');
                      }
                    }}
                  />
                  {calendarEvent?.is_recurring ? (
                    <Popover
                      opened={isDeletePopover}
                      position='right'
                      target={
                        <DeleteIcon
                          className='cursor-pointer'
                          onClick={() => setIsDeletePopover((o) => !o)}
                        />
                      }
                      withArrow
                    >
                      <div className='flex flex-col items-start text-[#616161]'>
                        <button
                          className='px-1 w-full hover:bg-[#fff1f1] rounded-md'
                          onClick={() => {
                            setIsDeletePopover(false);
                            props?.setOpenDeleteEventModal(true);
                            props?.setSelectEventToDelete(calendarEvent?.id);
                            props?.setTitle(
                              calendarEvent?.type === 'meeting'
                                ? `${calendarEvent?.title} Meeting`
                                : `${calendarEvent?.title} Event`
                            );
                          }}
                        >
                          Occurrence
                        </button>
                        <button
                          className='px-1 w-full text-left hover:bg-[#fff1f1] rounded-md'
                          onClick={() => {
                            setIsDeletePopover(false);
                            props?.setOpenDeleteEventModal(true);
                            props?.setSelectEventToDelete(calendarEvent?.id);
                            props?.setIsDeleteSeries(true);
                            props?.setTitle(
                              calendarEvent?.type === 'meeting'
                                ? `${calendarEvent?.title} Meeting`
                                : `${calendarEvent?.title} Event`
                            );
                          }}
                        >
                          Series
                        </button>
                      </div>
                    </Popover>
                  ) : (
                    <DeleteIcon
                      className='cursor-pointer'
                      onClick={() => {
                        props?.setOpenDeleteEventModal(true);
                        props?.setSelectEventToDelete(calendarEvent?.id);
                        props?.setTitle(
                          calendarEvent?.type === 'meeting'
                            ? `${calendarEvent?.title} Meeting`
                            : `${calendarEvent?.title} Event`
                        );
                      }}
                    />
                  )}
                </div>
              )}
          </div>
          <div className='flex items-center justify-between space-x-4 text-979797 text-12'>
            <p>
              {dateFormatter(calendarEvent?.start, 'DD MMM YY') ===
              dateFormatter(calendarEvent?.end, 'DD MMM YY') ? (
                dateFormatter(calendarEvent?.start, 'DD MMM YY')
              ) : (
                <>
                  <span>
                    {dateFormatter(calendarEvent?.start, 'DD MMM YY')}
                  </span>
                  <span>
                    {' '}
                    - {dateFormatter(calendarEvent?.end, 'DD MMM YY')}
                  </span>
                </>
              )}
            </p>
            <div>
              <p className='text-sm'>
                {calendarEvent.allDay
                  ? 'All Day'
                  : dayjs('2019-01-25' + calendarEvent?.from_time).format(
                      'h:mm A'
                    ) +
                    ' - ' +
                    dayjs('2019-01-25' + calendarEvent?.to_time).format(
                      'h:mm A'
                    )}
              </p>
            </div>
          </div>
          <Select
            defaultValue={'Accepted'}
            data={['Accepted', 'Rejected']}
            // disabled={!is_admin}
            disabled
            onChange={(event) =>
              editCalendarEventMutation.mutate({
                id: calendarEvent?.id,
                holiday_type_id: +event,
              })
            }
            rightSection={<DownArrowIcon />}
            className='mt-6'
            classNames={{
              input: 'border-0 text-979797 bg-FFE2D8',
              label: 'text-neutralsGrey',
            }}
            styles={{
              rightSection: {
                pointerEvents: 'none',
              },
            }}
          />
          <div className='mt-6'>
            {calendarEvent?.type === 'meeting' && (
              <div className='flex gap-4'>
                <span>
                  <LocationIcon />
                </span>
                <p className='text-neutralsGrey'>{calendarEvent?.location}</p>
              </div>
            )}
          </div>
          <div className='mt-4 mb-4'>
            <div className='flex gap-2  items-center'>
              <span>
                <MeetIcon className='w-6' />
              </span>
              <span>
                <Avatar
                  src={calendarEvent?.created_by_profile_pic}
                  size={35}
                  color='red'
                  radius={50}
                  className='capitalize'
                >
                  {calendarEvent?.created_by_name &&
                    calendarEvent?.created_by_name?.charAt(0)}
                </Avatar>
              </span>

              <p className='text-neutralsGrey'>
                {calendarEvent?.created_by_name}
              </p>
            </div>
          </div>
          <div>
            {calendarEvent?.location === 'Online' &&
              calendarEvent?.type === 'meeting' && (
                <a
                  href={`/meetingRoom/?room=${calendarEvent?.id}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <PrimaryButton>Join Meeting</PrimaryButton>
                </a>
              )}
          </div>
        </div>
      </Popover>
    </div>
  );
}
